export default __webpack_public_path__ + "static/media/image-science.04d5d632.jpg";